import React from 'react';
import PropTypes from 'prop-types';

// TODO: put this back after investigating the issue
// import LinkWithSearch from '../LinkWithSearch';
import Link from 'react-router-dom/Link';

const AppLink = props => {
  const {
    app: {
      isIntegration,
      links: { detail }
    },
    children
  } = props;
  return (
    <Choose>
      <When condition={isIntegration || detail.indexOf('http') > -1}>
        <span data-testid="AppLink__ExternalLink">
          <a href={detail} {...props}>
            {children}
          </a>
        </span>
      </When>
      <Otherwise>
        <span data-testid="AppLink__InternalLink">
          <Link to={detail} {...props}>
            {children}
          </Link>
        </span>
      </Otherwise>
    </Choose>
  );
};

AppLink.propTypes = {
  app: PropTypes.shape({
    isIntegration: PropTypes.bool.isRequired,
    links: PropTypes.shape({
      detail: PropTypes.string.isRequired
    }).isRequired
  }).isRequired,
  children: PropTypes.node.isRequired
};

export default AppLink;
